import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HttpClient from './../../../services/httpClient';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Button } from 'semantic-ui-react';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { useTranslation } from 'react-i18next';
import { finishLoading, setTitle, startLoading } from './../../../store/actions/uiAction';
import { logReportService } from './../../../services/logReportService';
import { MultiSelectComponent, CheckBoxSelection, Inject as InjectDrop } from '@syncfusion/ej2-react-dropdowns';

const NominasWalletStaffs = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [dateStart, setDateStart] = useState(null);
    const [dateEnd, setDateEnd] = useState(null);
    const user = useSelector(state => state.auth.currentUser);
    const { idSaleRoom, idHotel } = useSelector(state => state.user.param);
    const [colaboradoresData, setColaboradoresData] = useState([]);

    const checkFields = { text: 'Name', value: 'Code' };

    let mulObjColaboradores = null;

    const onChangeDateStart = (event, data) => setDateStart(data.value);
    const onChangeDateEnd = (event, data) => setDateEnd(data.value);

    const getDataReport = (url) => {
        dispatch(startLoading());
        return new Promise((resolve, reject) => {
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    reject(error);
                });
        });
    };

    const getOptionData = (url) => {
        return new Promise((resolve, reject) => {
            getDataReport(url).then((response) => {
                if (response.status === 200) {
                    const obj = response.data;
                    const res = [];
                    for (let i in obj) {
                        res.push({ Code: obj[i].id, Name: obj[i].name });
                    }
                    resolve(res);
                }
            }).catch(reject);
        });
    };

    const getColaboradoresData = () => {
        getOptionData('/catalog/colaboradores').then((response) => {
            setColaboradoresData(response);
        });
    };

    const exportExcelFromAPI = () => {
        const base_url = process.env.REACT_APP_URL_API_PATH;
        const idColaborador =
            mulObjColaboradores != null && mulObjColaboradores.value.length > 0
                ? mulObjColaboradores.value.map(String).toString()
                : '0';

        let url;
        if (dateStart && dateEnd) {
            const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
            const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');
            url = `${base_url}/contabilidad/documentos/nomina-ventas-colaborador-excel/${idColaborador}/${date1}/${date2}`;
        } else {
            url = `${base_url}/contabilidad/documentos/nomina-ventas-colaborador-excel/${idColaborador}`;
        }

        logReportService.add('Nominas Wallet Staffs', user);
        window.open(url, '_parent');
    };

    useEffect(() => {
        getColaboradoresData();
        dispatch(setTitle('Nominas Wallet Staffs'));
    }, []);

    return (
        <div className="container-fluid">
            {/* Filtros */}
            <div className="row">
                {/* Fecha inicio */}
                <div className="col-12 col-sm-6 col-md-3 form-group mb-3">
                    <label>Fecha inicio:</label>
                    <SemanticDatepicker
                        name="dateStart"
                        value={dateStart}
                        onChange={onChangeDateStart}
                    />
                </div>

                {/* Fecha fin */}
                <div className="col-12 col-sm-6 col-md-3 form-group mb-3">
                    <label>Fecha fin:</label>
                    <SemanticDatepicker
                        name="dateEnd"
                        value={dateEnd}
                        onChange={onChangeDateEnd}
                    />
                </div>

                {/* Colaboradores */}
                <div className="col-12 col-sm-6 col-md-4 form-group mb-3">
                    <label>Colaboradores:</label>
                    <MultiSelectComponent
                        id="colaboradores"
                        ref={(scope) => { mulObjColaboradores = scope; }}
                        dataSource={colaboradoresData}
                        fields={checkFields}
                        placeholder="Seleccionar colaboradores"
                        mode="CheckBox"
                        showSelectAll={true}
                        value={[]}
                        showDropDownIcon={true}
                        allowFiltering={true}
                        filterBarPlaceholder="Buscar colaborador"
                        popupHeight="350px"
                    >
                        <InjectDrop services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>

                {/* Botón */}
                <div className="col-12 col-md-2 form-group mb-3 d-flex align-items-end">
                    <Button positive onClick={exportExcelFromAPI}>
                        Export Report
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NominasWalletStaffs;
